import _filter from 'lodash/filter'

const pluckProductBundleId = (_, { productBundleId }) => productBundleId

const getProductBundleReasonsItems = (state) => state.productBundleReasons.items
export const getIsFetchingProductBundleReasons = (state) => state.productBundleReasons.isFetching
export const getIsFetchSuccessfulProductBundleReasons = (state) => state.productBundleReasons.fetchSuccessful

export const getProductBundleReasonsByProductBundleId = (state, ownProps) => {
    const reasons = getProductBundleReasonsItems(state)
    const productBundleId = pluckProductBundleId(state, ownProps)

    return _filter(reasons, { productBundleId })
}
